import { ColumnsByBreakpoint } from '../../helpers/columns/types';

export const defaultGridItemProps: ColumnsByBreakpoint = {
  desktop: 12,
  tabletLandscape: 12,
  tabletPortrait: 8,
  mobile: 4,
};
